import { useGlobalContext } from '../GlobalProvider';
import { Link, LoginButton as StyledButton } from './styledComponents';
import { useTranslation } from 'next-i18next';

interface Props {
  className?: string;
}

const LoginButton = (props: Props) => {
  const { programmeId = 'BAEC' } = useGlobalContext();
  const { t } = useTranslation(`${programmeId.toUpperCase()}/login`);

  return (
    <Link href="/auth/login" {...props}>
      <StyledButton label={t('loginButton')} />
    </Link>
  );
};

export default LoginButton;
